<template>
  <modal id="softApproval" class="soft-approval">
    <div slot="content">
      <div class="content-x">
        <p class="soft-approval__content text-center">
          This template should only be used if you have received approval from Warner Media's / Turner's Greenlight
          committee.
        </p>
        <p class="soft-approval__content text-center">
          By going ahead with this competition, you acknowledge that you have presented your case and obtained
          appropriate approval to go ahead.
        </p>
        <p class="soft-approval__content text-center">
          Please select from the dropdown list below a Super Admin to notify them that you have received authorisation
          to use this template.
        </p>
        <p class="soft-approval__content text-center">An email notification will be sent to them for their records.</p>
      </div>
      <div class="grid-x align-center">
        <div class="cell large-5 grid-x align-justify">
          <multiselect
            v-model="selectedAdmin"
            :options="admins"
            :close-on-select="true"
            :clear-on-select="false"
            label="name"
            track-by="id"
            select-label
            selected-label
            deselect-label
            :max-height="90"
          />
        </div>
      </div>
      <div class="grid-x align-center">
        <div class="cell large-5 grid-x align-justify">
          <formButton @click="cancel">Cancel</formButton>
          <formButton :disabled="!selectedAdmin" @click="confirm">Acknowledge and continue</formButton>
        </div>
      </div>
    </div>
    <div slot="header" />
  </modal>
</template>

<script>
import formButton from '@/components/common/form-button/form-button.vue'
import Multiselect from 'vue-multiselect'
import modal from '@/components/common/modal/modal.vue'
import { mapActions } from 'vuex'

export default {
  components: {
    formButton,
    Multiselect,
    modal
  },
  data() {
    return {
      selectedAdmin: null,
      admins: []
    }
  },
  computed: {},
  created() {
    this.getUsers({
      status: 'enabled',
      role: 'admin',
      sort_by: 'name'
    }).then((response) => {
      this.admins = response.data.slice()
    })
  },
  methods: {
    ...mapActions('popup', ['setCurrentPopup']),
    ...mapActions('user', ['getUsers']),
    cancel: function () {
      this.setCurrentPopup(null)
      this.$emit('cancel')
    },
    confirm: function () {
      this.setCurrentPopup(null)
      this.$emit('confirm', this.selectedAdmin)
    }
  }
}
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style src="./soft-approval.scss" lang="scss"></style>



// WEBPACK FOOTER //
// src/components/common/soft-approval/soft-approval.vue